import { render, staticRenderFns } from "./SearchHeaderWidget.vue?vue&type=template&id=53458e8c&"
import script from "./SearchHeaderWidget.vue?vue&type=script&lang=js&"
export * from "./SearchHeaderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports